module.exports = __webpack_public_path__ + "static/img/d_smtj.42dbb13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/d_smtj.png
// module id = LG1m
// module chunks = 1